import { authUserInfoApi } from '@/api/user';
import { USER_REGISTER_CLEAR, USER_REGISTER_UPDATE, USER_REGISTER_WECHAT_CLEARN, USER_REGISTER_WECHAT_UPDATE, USER_USERINFO_CLEAR, USER_USERINFO_UPDATE } from '../mutationTypes';

const initState = {
  userInfo: {
    isUpdate: false,
  },
  registerInfo: {
    phone: '',
    invite: '',
    password: '',
    rPassword: '',
    code: '',
    biz: '',
  },
  registerWechatInfo: {
    phone: '',
    invite: '',
    password: '',
    rPassword: '',
    code: '',
    biz: '',
    wechatId: '',
    city: '杭州',
    country: '',
    headimgurl: '',
    language: '',
    nickname: '',
    openid: '',
    province: '',
    sex: 1,
    unionid: '',
  },
};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};
const getters = {};
const mutations = {
  // 用户信息清除
  [USER_USERINFO_CLEAR](states, newValue = initState.registerInfo) {
    const registerInfo = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { registerInfo });
  },
  // 用户信息更新
  [USER_USERINFO_UPDATE](states, newValue = state.userInfo) {
    const userInfo = Object.assign(state.userInfo, newValue);
    Object.assign(states, { userInfo });
  },
  // 注册表单初始化
  [USER_REGISTER_CLEAR](states, newValue = initState.registerInfo) {
    const registerInfo = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { registerInfo });
  },
  // 注册表单更新
  [USER_REGISTER_UPDATE](states, newValue = state.registerInfo) {
    const registerInfo = Object.assign(state.registerInfo, newValue);
    Object.assign(states, { registerInfo });
  },
  // 微信注册表单初始化
  [USER_REGISTER_WECHAT_CLEARN](states, newValue = initState.registerWechatInfo) {
    const registerWechatInfo = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { registerWechatInfo });
  },
  // 微信注册绑定表单更新
  [USER_REGISTER_WECHAT_UPDATE](states, newValue = state.registerWechatInfo) {
    const registerWechatInfo = Object.assign(state.registerWechatInfo, newValue);
    Object.assign(states, { registerWechatInfo });
  },
};
const actions = {
  async fetchUserInfoAction(states, to) {
    const stateUserInfo = states.state.userInfo || {};
    if (!stateUserInfo.userId) {
      const resData = await authUserInfoApi({}, { to });
      const userInfo = { ...(resData.data || {}), isUpdate: true };
      Object.assign(states.state, { userInfo });
    } else {
      Object.assign(states.state, { userInfo: { ...stateUserInfo, isUpdate: true } });
    }
    return states.state.userInfo;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
